import {
    PROFILE_DETAILS, NOTIFICATIONS, FOLLOWING_USERS, FOLLOWERS, AUTH_USER_DETAILS
} from '../actions/Types';
import {profileAttributes, updateUserAttributesLocalStorage, userAttributes} from "../actions/Common";
const INITIAL_STATE = {
    profileData:{},
    authUserDetails:{}
  }
export default (state = INITIAL_STATE, action) =>
{
    switch(action.type)
    {
        case PROFILE_DETAILS:
            updateUserAttributesLocalStorage('avatar', action.payload.avatar);
            return {...state, profileData: action.payload};

        case AUTH_USER_DETAILS:
            const authUserDetails = profileAttributes(action.payload);
            return {...state, authUserDetails: authUserDetails};

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./reducers/UserReducer.js